import React from 'react';
import { Link } from 'gatsby';

import { Section } from '..';

import unsolvedCase from './assets/unsolvedCase.jpg';
import unboxing from './assets/unboxing.jpg';
import parallelLab from './assets/parallelLab.jpg';

import style from './BrowseGamesSection.module.less';

export const BrowseGamesSection = () => (
  <Section className={style.ourGames}>
    <h1 id="ourGames">Cooperative Puzzle Games</h1>
    <div className={style.row}>
      <div className={style.game}><Link to="/unsolved-case"><img src={unsolvedCase} alt="Unsolved Case" /></Link></div>
    </div>
    <div className={style.row}>
      <div className={style.game}><Link to="/unboxing-the-cryptic-killer"><img src={unboxing} alt="Unboxing the Cryptic Killer" /></Link></div>
    </div>
    <div className={style.row}>
      <div className={style.game}><Link to="/parallel-experiment"><img src={parallelLab} alt="Parallel Experiment" /></Link></div>
    </div>
  </Section>
);
